import { Typography } from '@mui/material';
import React from 'react';

import { colors } from '../theme/theme';

interface TextFieldTitleProps {
    title: string;
    required?: boolean;
}

// Shared "field label + required asterisk" heading used by TextFieldComponent, TextAreaComponent,
// and PhoneInputComponent.
export const TextFieldTitle: React.FC<TextFieldTitleProps> = ({ title, required }) => (
    <Typography variant="subtitle2" className="textFieldTitle">
        {title}
        {required && (
            <Typography component="span" sx={{ color: colors.errorPreset[10], ml: 0.5 }}>
                *
            </Typography>
        )}
    </Typography>
);

interface TextFieldErrorProps {
    errorValue: string;
}

// Shared simple error message used by TextAreaComponent and PhoneInputComponent. (The
// TextFieldComponent uses a richer, more accessible variant with additional aria attributes
// and is left as-is.)
export const TextFieldError: React.FC<TextFieldErrorProps> = ({ errorValue }) => (
    <Typography variant="subtitle2" className="errorTxt">
        {errorValue}
    </Typography>
);
